import { render, staticRenderFns } from "./ConnectRewardsForm.vue?vue&type=template&id=156a12bb"
import script from "./ConnectRewardsForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConnectRewardsForm.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ConnectRewardsForm.vue?vue&type=style&index=0&id=156a12bb&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports